import React from 'react';
import { useAppState } from '../../context/AppStateProvider';
import { FileText } from 'lucide-react';

const UtilityScratchpad = () => {
  const { scratchpad, setScratchpad } = useAppState();

  return (
    <div className="utility-section" data-testid="utility-scratchpad">
      <div className="utility-header">
        <FileText size={16} className="utility-icon" />
        <h3 className="utility-title">Scratchpad</h3>
      </div>
      <textarea
        value={scratchpad}
        onChange={(e) => setScratchpad(e.target.value)}
        placeholder="Quick notes, ideas, reminders..."
        className="scratchpad-textarea"
        data-testid="scratchpad-textarea"
      />
    </div>
  );
};

export default UtilityScratchpad;
